"use strict";

module.exports = function (fn) {
	if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
	return fn;
};



// WEBPACK FOOTER //
// ./node_modules/event-emitter/node_modules/es5-ext/object/valid-callable.js